export default {"src":"/_next/static/media/nieng-rang-tham-my.1e84fe58.svg","height":100,"width":101,"blurWidth":0,"blurHeight":0};